import { useNavigationSettings } from 'hooks/useNavigationSettings'

/**
 * Определяет, когда layout должен быть во весь экран.
 */
export const useIsScreenHeightLayout = () => {
  const { isRatingSettingsPath, isSearchSettingsPath } = useNavigationSettings()
  const isScreenHeightLayout = isRatingSettingsPath || isSearchSettingsPath

  return isScreenHeightLayout
}
